export default __webpack_public_path__ + "static/yeti-fur-dk-e4b0a7e3f55c4a089ee3eb847307f6ba.jpg";